/** @format */

import { api } from 'utility';
import {
  getAddOrRemoveServiceCallUrl,
  getServiceSetUrl,
  getMyServiceCalListlUrl,
  getServiceCallUrl,
  getPublishOrUnPublishServiceSetUrl,
  getExportServiceSetUrl,
  getServiceSetDetailUrl,
} from 'URLs';
const source = api.cancelToken;
let cancelToken;

export function addOrRemoveServiceCallApi(params) {
  return api.post(getAddOrRemoveServiceCallUrl(), params);
}

export function serviceSet(params) {
  return api.get(getServiceSetUrl(), { params });
}

export function serviceSetId(param) {
  const paramsApi = {
    ...param.pagination,
    id: param.id,
  };
  return api
    .get(getServiceSetUrl(), {
      params: { ...paramsApi },
    })
    .then((res) => res.data);
}

export function addServiceSetApi(params) {
  return api.post(getServiceSetUrl(), {
    ...params,
  });
}

export function updateServiceSetApi(params) {
  return api.put(getServiceSetUrl(), {
    ...params,
  });
}

export function myServiceSetList(param) {
  return api.get(getMyServiceCalListlUrl(), {
    params: { offset: 0, size: 10, ...param },
  });
}

export function publishServiceSetApi(id) {
  return api.post(getPublishOrUnPublishServiceSetUrl(id));
}

export function unPublishServiceSetApi(id) {
  return api.delete(getPublishOrUnPublishServiceSetUrl(id));
}

export function exportServiceSetApi() {
  return api.post(getExportServiceSetUrl());
}

export function getServiceSetDetailsApi(id) {
  return api.get(getServiceSetDetailUrl(id)).then((res) => res.data);
}

export function getServiceCallApi(params) {
  if (cancelToken) {
    cancelToken.cancel('cancelToken');
  }

  cancelToken = source.source();

  return api
    .get(getServiceCallUrl(), {
      cancelToken: cancelToken.token,
      params,
    })
    .then((res) => res.data);
}
